module.exports = __webpack_public_path__ + "img/7_119.7afbf1fe.png";